import $ from 'jquery';

const adBlockerPromise = () => {

    const elements = document.head.getElementsByTagName('script');
    const scriptsToCheck = Array
        .from(elements)
        .map((el) => el.src)
        .filter((el) => el.includes('optad360.io/'))

    scriptsToCheck.forEach((src) => {
        fetch(src, {
            method: 'GET',
            mode: 'no-cors',
        }).then((response) => {
            // console.log(`response for ${src}`, response)
            // If the request is redirected, then the ads are blocked.
            if (response.redirected) {
                window.dispatchEvent(new CustomEvent('onScriptFailedToLoad'))
            } else {
                window.dispatchEvent(new CustomEvent('onScriptLoaded'))
            }
        }).catch(() => {
            // If the request fails completely, then the ads are blocked.
            window.dispatchEvent(new CustomEvent('onScriptFailedToLoad'))
        })
    })

    const scriptFailedListener = () => {
        const event = new CustomEvent('onAdBlockerDetectionFinish', { detail: true });
        window.dispatchEvent(event);
        dataLayer.push({
            'event': 'adBlockDetection',
            'detection': 1,
        });
    }

    let scriptLoadedOccurrence = 0

    const scriptLoadedListener = () => {
        scriptLoadedOccurrence++
        if (scriptLoadedOccurrence >= scriptsToCheck.length) {
            const event = new CustomEvent('onAdBlockerDetectionFinish', { detail: false });
            window.dispatchEvent(event);
            dataLayer.push({
                'event': 'adBlockDetection',
                'detection': 0,
            });
            window.removeEventListener('onScriptLoaded', scriptLoadedListener);
        }

    }

    window.addEventListener('onScriptFailedToLoad', scriptFailedListener, { once: true });
    window.addEventListener('onScriptLoaded', scriptLoadedListener);
};

export default {
    init() {
        /*
         * Send it on window ready, to keep specify order
         * 1. declare event listeners
         * 2. emit events
         */
        $(window).ready(() => {
            adBlockerPromise();
        });
    },
};



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/ui/ad-block-detector/index.js